module.exports = "pegasus_template/assets/themecapture1/small/0.png";